import * as model from './models';

import axios from 'axios';

/** 模版模块接口  模板列表分类 */
export async function showCategoriesUsingPOST() {
  const headers: Record<string, string> = Object.create(null);
  headers['Content-Type'] = 'application/json';

  const result = await axios.request<model.IMessageListTemplateCategoryView>({
    url: `/rest/ad/inavad/template/category`,
    method: 'post',
    headers,
  });
  return result.data;
}

/** 模版模块接口  创建模版 */
export async function createTemplateUsingPOST(payload: { req: model.ITemplateBaseInfo }) {
  const data = {
    ...payload.req,
  };
  const headers: Record<string, string> = Object.create(null);
  headers['Content-Type'] = 'application/json';

  const result = await axios.request<model.IMessageTemplateInfoView>({
    url: `/rest/ad/inavad/template/create`,
    method: 'post',
    data,
    headers,
  });
  return result.data;
}

/** 模版模块接口  模版详情 */
export async function infoUsingPOST(payload: { templateId: string }) {
  const params = {
    templateId: payload.templateId,
  };
  const headers: Record<string, string> = Object.create(null);
  headers['Content-Type'] = 'application/json';

  const result = await axios.request<model.IMessageTemplateInfoView>({
    url: `/rest/ad/inavad/template/info`,
    method: 'post',
    params,
    headers,
  });
  return result.data;
}

/** 模版模块接口  模版列表 */
export async function listUsingPOST(payload: { req: model.ITemplateListReq }) {
  const data = {
    ...payload.req,
  };
  const headers: Record<string, string> = Object.create(null);
  headers['Content-Type'] = 'application/json';

  const result = await axios.request<model.IMessagecommonListResultTemplateInfoView>({
    url: `/rest/ad/inavad/template/list`,
    method: 'post',
    data,
    headers,
  });
  return result.data;
}

/** 模版模块接口  模版更新 */
export async function updateTemplateUsingPOST(payload: { req: model.ITemplateUpdateReq }) {
  const data = {
    ...payload.req,
  };
  const headers: Record<string, string> = Object.create(null);
  headers['Content-Type'] = 'application/json';

  const result = await axios.request<model.IMessageTemplateInfoView>({
    url: `/rest/ad/inavad/template/update`,
    method: 'post',
    data,
    headers,
  });
  return result.data;
}

/** 模版模块接口  使用模版 */
export async function useTemplateUsingPOST(payload: { templateId: string }) {
  const params = {
    templateId: payload.templateId,
  };
  const headers: Record<string, string> = Object.create(null);
  headers['Content-Type'] = 'application/json';

  const result = await axios.request<model.IMessageProjectInfoView>({
    url: `/rest/ad/inavad/template/use`,
    method: 'post',
    params,
    headers,
  });
  return result.data;
}
